export function getExpiryDate(milisecondsFromNow) {
    return new Date(new Date().getTime()+milisecondsFromNow);
}

export function hasDateExpired(dateNow,expireDate) {
    return !expireDate || expireDate <= dateNow
}